export default __webpack_public_path__ + "static/media/2_0076.ba5947d3.webp";